<template>
  <div class="d-flex flex-column">
      <!-- <v-card class="mt-5 mb-5" v-if="!$route.path.includes('edit')">

          <v-card-title
              class="text_primary"
         >
            {{ `店長` }}
          </v-card-title>

          <v-divider></v-divider>
          
          <v-card-text>
            {{ displayEmail }}
          </v-card-text>

      </v-card> -->
      <v-card class="mt-5" v-if="!$route.path.includes('edit')">
          <v-card-title
              class="text_primary"
          >

            {{ page_title }}
            
            <v-spacer></v-spacer>

            <v-btn
                class="mr-2 white--text"
                color="#5087e6"
                @click="newContainer"
            >
              <!-- <v-icon
                left
              >
                mdi-plus-circle
              </v-icon> -->
              新增
            </v-btn>

          </v-card-title>

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-footer
            :items-per-page="1000"
          >

            <template v-slot:[`item.user_name`] = "{item}">
              <p style="margin-bottom: 0px;">
                {{ item.is_admin ? `${item.user_name}  (管理員)` : item.user_name }}
              </p>
            </template>
            
            <template v-slot:[`item.actions`] = "{item}">

              <div class="d-flex">

                <v-btn
                  v-if="is_principal['email'] !== item.email"
                  class="text_default btn_default btn_default_bg_linear"
                  outlined
                  @click="viewInfo(item)"
                >
                  {{btn.view}}
                </v-btn>
                
                <v-btn
                  v-if="item['email'] !== loggedInfo.email && is_principal['email'] !== item.email"
                  @click="removeOrgMember(item)"
                  :color="$vuetify.theme.themes['dark']['warning']"
                  class="btn-danger ml-4"
                >
                    移除
                </v-btn>

                <div
                  v-else
                  class="d-flex align-center"
                  style="margin: 0px 0px 0px 16px;"
                >

                  <div v-if="is_principal['email'] === item.email"></div>
                  <div v-else>這是你！</div>
                </div>

              </div>

            </template>


          </v-data-table>

          <DialogForm 
            v-if="is_show_new_dialog"
            :dialogSetting="dialog_setting"
            @addStaff="addStaff"
            @close="closeNewDialog"
          />

          <LoadingOverlay 
              :isLoading="isLoading"
          />

      </v-card>
  </div>
    
</template>

<script>

import DialogForm from '@/components/Utils/DialogForm.vue'
import LoadingOverlay from "@/components/Utils/LoadingOverlay.vue";

import {
   apiGetStaff,
   apiCreateStaff,
   apiGetAuths,
   apiDeleteStaff
} from '@/api/organize.js'

import { mapGetters } from 'vuex'

  export default {
    name: 'StaffList',
    components: {
      DialogForm,
      LoadingOverlay
    },
    data: function(){
      return {
        
        isLoading: false,

        // 頁面名稱
        page_title: '成員列表',

        items: [],

        // value值對應到後端Api欄位，除了current_user跟actions之外都是
        headers: [
          // { text: '管理員', value: 'is_principal', sortable: false,},
          { text: '名稱', value: 'user_name', sortable: false,},
          { text: '電郵', value: 'email', sortable: false,},
          // { text: '當前使用者', value: 'current_user', sortable: false,},
          { text: '', value: 'actions', sortable: false },
        ],
        btn: {
          "view": "編輯"
        },

        is_show_new_dialog: false,

        dialog_setting: {
          title: '新增管理員',
          fields: [
            {
              "id": "email",
              "label": "電郵",
              "value": null,
              "hint": "example@example.com",
              "type": "text"
            }
          ],
          submit_text: '新增',
          submit_callback: 'addStaff',
          close_callback: 'close',
          views: null
        },

        is_principal: null
      }
    }, 
    created: async function(){
      try {
        this.isLoading = true
        await this.handleItems()
        await this.apiGetAuths()
      } catch (e) {
        console.log(e);
        this.$root.vtoast.show({ message: e.name + ': ' + e.message , color: 'error'})
      } finally {
        this.isLoading = false
      }
    },
    mounted: function(){
        console.log('yo Staff List')
    },
    methods: {
      /**
       * 處理管理員清單，將店長放置到is_principal這個data變數然後移除，並且比對登入資訊判斷當前使用者是誰。
       */
      async handleItems() {
        this.items =  await this.getStaffs()
        this.is_principal = this.items[0]
        console.log('StaffList ',this.items);
        console.log("is_principal", this.is_principal);
        console.log('this', this.items)
        // this.items.shift()
        // this.items = this.items.reduce( (acc,cur) => {
        //   return [...acc, { ...cur, current_user : false} ]
        // },[])
        
        // this.items = this.items.map( item => {
        //   if (item.email.includes(this.loggedInfo.email)) {
        //     return { ...item, current_user : true}
        //   }
        //   return item
        // })
      },
      async apiGetAuths() {
        await apiGetAuths(this.selected_organize.org_id)
          .then(resp => {
            console.log(resp);
          })
          .catch(error => {
            console.log(error);
          })
      },
      getStaffs: async function(){
        let that = this
        let data = []
        data = await apiGetStaff(this.selected_organize.org_id).then(function(resp){

          console.log(resp);
          let sort_data = resp.data.data.sort( (a, b) => b.is_principal - a.is_principal )
          that.is_principal = sort_data[0]
          return sort_data
        }).catch(function(error){
          console.log(error)
          if (error.includes('401')) {
            that.$root.vtoast.show({
              message: `沒有權限使用此功能，原因: ${error}`
            })
            that.$router.push(`/${that.$route.params.org_id}/401`)
          }
          else {
            that.$root.vtoast.show({message: `取得管理員失敗，原因: ${error}`})
          }

          return []
        })
        return data
      },
      newContainer: function(){
        this.is_show_new_dialog = true
      },
      closeNewDialog: function(){
        this.is_show_new_dialog = false
      },
      addStaff: async function(fields){
        let param = {}
        let that = this
        fields.forEach(function(field){
          param[field.id] = field.value
        })
        await apiCreateStaff(param, this.selected_organize.org_id).then(function(resp){
          const { data } = resp
          console.log(data)
          if (data.ok === 1) {
            that.$root.vtoast.show({
              message: "新增管理員成功，請至信箱收信！"
            })
            that.is_show_new_dialog = false
            that.handleItems()
          } else {
            that.$root.vtoast.show({
              message: `新增管理員失敗，原因: ${data.msg}`
            })
          }
        }).catch(function(error){
          console.error('新增管理員錯誤: ',error)
					that.$root.vtoast.show({
						message: "新增管理員錯誤，原因: " + error.response ? error.response : error
					})
        })
        console.log(param)
      },
      viewInfo: async function(selected_admin){
        console.log(selected_admin);
        this.$store.commit('selected_admin', selected_admin)
        this.$router.push(`/${this.selectedOrg.org_id}/setting/staffs/${selected_admin.id}/edit`)
      },
      removeOrgMember(item) {
          console.log(item)
          let confirm_dialog = confirm(`請問您確定要將 ${item['user_name']} 移除組織嗎？`)
          let param = {
            email: item['email']
          }
          if (confirm_dialog) {
              // this.isLoading = true
              
              apiDeleteStaff(this.selected_organize.org_id, param)
                .then( resp => {
                    console.log(resp);
                    // ES6 賦值解構語法
                    let { data } = resp

                    if (data['ok'] === 1) {
                      this.handleItems()
                      this.$root.vtoast.show({
                        message: `移除組織成員 ${item['user_name']} 成功 !`,
                        color: 'primary'
                      })
                    } else {
                      this.$root.vtoast.show({
                        message: `移除組織成員異常，原因: ${data['msg']}`,
                      })
                    }
                })
                .catch( error => {
                    this.$root.vtoast.show({
                      message: "移除組織成員錯誤，原因: " + error.response ? error.response : error
                    })
                })
                .finally(
                  // this.isLoading = false
                )
          } else {
            console.log("不移除");
          }
      },
    },
    watch: {
    },
    computed: {
      selected_organize() {
        return this.$store.getters.selectedOrg
      },
      selected_admin() {
        return this.$store.getters.selectedAdmin
      },
      ...mapGetters(['selectedOrg','loggedInfo']),
      displayEmail() {
        return this.is_principal?.['email']
      }
    }     
  }
</script>
<style scoped>
  h4 {
      color: #5b5b5b;
  }
</style>